import { MutationTree } from "vuex";
import { IDataProvider } from "@/store";
import { IEntityApprovalRequest } from "@/types/common/entityApproval/EntityApproval";
import { IEntityApprovalState } from "@/store/modules/entityApproval/state";

export enum EntityApprovalMutations {
  SET_LAZY_DATA = "SET_LAZY_DATA_ENTITY_APPROVAL",
}

export const mutations: MutationTree<IEntityApprovalState> = {
  [EntityApprovalMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<IEntityApprovalRequest>
  ) {
    state.dataProvider = payload;
  },
};
